"use client";

import { motion } from "framer-motion";
import WhatsAppCTA from "./ui/button";
import BackgroundVideo from "./ai/background";

export default function AISection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] lg:h-[800px] overflow-hidden">
      <BackgroundVideo />
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">
        <motion.h2
          className="font-bold text-white leading-tight
					 text-3xl sm:text-4xl md:text-5xl lg:text-6xl
						font-bold
						mb-2"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          Escape do comum. <br />
          <span className="text-[#5BE5FF]">Viva o extraordinário.</span>
        </motion.h2>
        <motion.p
          className="text-lg md:text-xl lg:text-2xl text-gray-100 max-w-3xl mb-8"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          Transforme sua empresa em referência de inovação e experiências
          memoráveis, combinando tecnologia, criatividade e Inteligência
          Artificial personalizada.
        </motion.p>

        <motion.div
          className="w-full flex items-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          <WhatsAppCTA />
        </motion.div>
      </div>
    </section>
  );
}
